import { render, staticRenderFns } from "./RetoureV2.vue?vue&type=template&id=5f1834c8&scoped=true"
import script from "./RetoureV2.vue?vue&type=script&lang=js"
export * from "./RetoureV2.vue?vue&type=script&lang=js"
import style0 from "./RetoureV2.vue?vue&type=style&index=0&id=5f1834c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1834c8",
  null
  
)

export default component.exports